import { getStringHashCode26igk1bx568vk as getStringHashCode } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var GrantSlackAccessInputClass;
function GrantSlackAccessInput() {
  if (GrantSlackAccessInputClass === VOID) {
    class $ {
      constructor(code, state) {
        this.c6t_1 = code;
        this.d6t_1 = state;
      }
      toString() {
        return 'GrantSlackAccessInput(code=' + this.c6t_1 + ', state=' + this.d6t_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.c6t_1);
        result = imul(result, 31) + getStringHashCode(this.d6t_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof GrantSlackAccessInput()))
          return false;
        if (!(this.c6t_1 === other.c6t_1))
          return false;
        if (!(this.d6t_1 === other.d6t_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'GrantSlackAccessInput');
    GrantSlackAccessInputClass = $;
  }
  return GrantSlackAccessInputClass;
}
//region block: exports
export {
  GrantSlackAccessInput as GrantSlackAccessInput3j0s7of1xul8d,
};
//endregion

//# sourceMappingURL=GrantSlackAccessInput.mjs.map
